// FILE: src/router/index.js
import Vue from 'vue';
import VueRouter from 'vue-router';
import Login from '../views/Login.vue';
// import Dashboard from '../views/Dashboard.vue';
import NotFound from '../views/NotFound.vue';
import auth from '../services/auth.js';
import RegistrationForm from '../views/RegistrationForm.vue';
import ReportsPage from '../views/ReportsPage.vue';
import MaintenancePage from '../views/MaintenancePage.vue';
import ProfilePage from '../views/ProfilePage.vue';
import EvaluationPage from '../views/EvaluationPage.vue';
import HomePage from '../views/HomePage.vue';
import SeatingInquiry from '../views/SearchStudent/SeatingInquiry.vue';
import AboutView from '../views/AboutView.vue';
import DashboardLayout from '../views/DashboardLayout.vue';
import SetNumberScu from '../views/reNumberScur.vue';
import StudentAbs from '../views/studentAbs/StudentAbs.vue';
import StudentAbsAll from '../views/studentAbs/StudentAbsAll.vue';
import CountStatistics from '../views/studentAbs/CountStatistics.vue';
import CountStatisticsAll from '../views/studentAbs/CountStatisticsAll.vue';
import DeliveryPortfolio from '../views/studentAbs/DeliveryPortfolio.vue';
import DeliveryPortfolioAll from '../views/studentAbs/DeliveryPortfolioAll.vue';
import StoreDegreeStudent_1 from '../views/subjectsStudent/StoreDegreeStudent_1.vue';
import StoreDegreeStudent_2 from '../views/subjectsStudent/StoreDegreeStudent_2.vue';
import SingleGradeEdit from '../views/subjectsStudent/SingleGradeEdit.vue';
import ExternalGradeMonitoring from '../views/subjectsStudent/ExternalGradeMonitoring.vue';
import ReviewGradeSheet from '../views/subjectsStudent/ReviewGradeSheet.vue';
import ReviewGradeSheetAll from '../views/subjectsStudent/ReviewGradeSheetAll.vue';
import GradeAudit from '../views/subjectsStudent/GradeAudit.vue';
import CheckDegreeFailure from '../views/subjectsStudent/CheckDegreeFailure.vue';
import CallSheet from '../views/CallSheet/CallSheet.vue';
import SchoolCallingSheet from '../views/CallSheet/SchoolCallingSheet.vue';
import AbsenceSheetEmpty from '../views/CallSheet/AbsenceSheetEmpty.vue';
import CallSheetWithSubjectsAllMange from '../views/CallSheet/CallSheetWithSubjectsAllMange.vue';
import SecretRoomStaticSheet from '../views/SecretRoom/SecretRoomStaticSheet.vue';
import CommitteeChairmanAgenda from '../views/CommitteeChairmanAgenda/CommitteeChairmanAgenda.vue';
import CommitteeDistribution from '../views/CommitteeChairmanAgenda/CommitteeDistribution.vue';
import ActivityFirstOne from '../views/Activity/ActivityFirstOne.vue';
import ActivityAll from '../views/Activity/ActivityAll.vue';
import FinalResultPrint from '../views/ResultPrint/FinalResultPrint.vue';
import DigitalResultGazette from '../views/ResultPrint/DigitalResultGazette.vue';
import FrequencyReport from '../views/ResultPrint/FrequencyReport.vue';
import CumulativeFrequency from '../views/ResultPrint/CumulativeFrequency.vue';
import CumulativeFrequency_1 from '../views/ResultPrint/CumulativeFrequency_1.vue';
import SchoolActivitiesEntry from '../views/Activity/SchoolActivitiesEntry.vue';
import SchoolManagerInstructions from '../views/Activity/SchoolManagerInstructions.vue';
import CommitteeCommunication from '../views/CommitteeChairmanAgenda/CommitteeCommunication.vue';
import AdminSendInstruction from '../views/Admin/AdminSendInstruction.vue';
import AdminComplaintsDashboard from '../views/Admin/AdminComplaintsDashboard.vue';
import AdminSentInstructionsNotes from '../views/Admin/AdminSentInstructionsNotes.vue';
import AdminSentInstructionsNotes_2 from '../views/Admin/AdminSentInstructionsNotes_2.vue';
import CommitteeAbsenceRecorder from '../views/CommitteeChairmanAgenda/CommitteeAbsenceRecorder.vue';
import Statistics from '../views/Admin/Statistics.vue';

import IntegrationSecretReport from '../views/IntegrationSecretReport/IntegrationSecretReport.vue';
import SupplementaryExamReport from '../views/IntegrationSecretReport/SupplementaryExamReport.vue';
import CommitteeSupplementaryReport from '../views/IntegrationSecretReport/CommitteeSupplementaryReport.vue';
import FullAbsenceReport from '../views/IntegrationSecretReport/FullAbsenceReport.vue';
import MergePaperReceipt from '../views/IntegrationSecretReport/MergePaperReceipt.vue';
import LanguagePaperPrint from '../views/IntegrationSecretReport/LanguagePaperPrint.vue';
import SuccessCertificate from '../views/SuccessCertificate/SuccessCertificate.vue';
import GroupMirrorSheet from '../views/PosterPrint/GroupMirrorSheet.vue';
import EnvelopeStickers from '../views/PosterPrint/EnvelopeStickers.vue';
import SchoolStickerPrint from '../views/PosterPrint/SchoolStickerPrint.vue';
import VisualGradeReview from '../views/subjectsStudent/VisualGradeReview.vue';
import AnomaliesReview from '../views/subjectsStudent/AnomaliesReview.vue';
import AppealsRequest from '../views/AppealsRequest/AppealsRequest.vue';
import CentralPaperMonitor from '../views/AppealsRequest/CentralPaperMonitor.vue';
import ReadyAppealsList from '../views/AppealsRequest/ReadyAppealsList.vue';
import ControlEditAppeal from '../views/AppealsRequest/ControlEditAppeal.vue';
import FinalAppealMonitor from '../views/AppealsRequest/FinalAppealMonitor.vue';
import MercyRulesManager from '../views/subjectsStudent/MercyRulesManager.vue';
import MercyFullTable from '../views/subjectsStudent/MercyFullTable.vue';
import SystemSettings from '../views/SystemSettings/SystemSettings.vue';
import GradesCalculator from '../views/subjectsStudent/GradesCalculator.vue';
import CallSheetWithSubjects from '../views/CallSheet/CallSheetWithSubjects.vue';
import AbsenceEntry from '../views/CallSheet/AbsenceEntry.vue';
import GeneralStatistics from '../views/Report/GeneralStatistics.vue';
import SubjectsStatistics from '../views/Report/SubjectsStatistics.vue';
import ResultPortal from '../views/SearchStudent/ResultPortal.vue';
import SeatingReviewReport from '../views/CallSheet/SeatingReviewReport.vue';
import StudentInquiryOn from '../views/SearchStudent/StudentInquiryOn.vue';
import CommitteeEnvelopeLabel from '../views/PosterPrint/CommitteeEnvelopeLabel.vue';
import SchoolEnvelopeLabel from '../views/PosterPrint/SchoolEnvelopeLabel.vue';
import ChairmanLoginSheet from '../views/PosterPrint/ChairmanLoginSheet.vue';
import ExamPaperViewer from '../views/AppealsRequest/ExamPaperViewer/ExamPaperViewer.vue';
import MultiPageScanner from '../views/AppealsRequest/ExamPaperViewer/MultiPageScanner.vue';
import AppealReviewPage from '../views/AppealsRequest/ExamPaperViewer/AppealReviewPage.vue';
import PaperQualityReview from '../views/AppealsRequest/ExamPaperViewer/PaperQualityReview.vue';
import FinalAdminReport from '../views/AppealsRequest/ExamPaperViewer/FinalAdminReport.vue';
import OperationsDashboard from '../views/Admin/OperationsDashboard.vue';
import CommitteeStatsReport from '../views/Report/CommitteeStatsReport.vue';
import SeatingDistribution from '../views/SystemSettings/SeatingDistribution.vue';
import SeatingCardsPrint from '../views/SystemSettings/SeatingCardsPrint.vue';
import ExportDataCenter from '../views/SystemSettings/ExportDataCenter.vue';
Vue.use(VueRouter);

const routes = [

    {
        path: '/dashboard',
        component: DashboardLayout, // المكون الحاوي
        // يمكنك إضافة حماية للمسارات هنا للتأكد أن المستخدم مسجل دخوله
        meta: { requiresAuth: true },
        children: [
          { path: '', name: 'Dashboard', component: DashboardLayout },
          { path: 'Reports', name: 'Reports', component: ReportsPage },
          { path: 'StudentInquiryOn', name: 'StudentInquiryOn', component: StudentInquiryOn , meta: { roles: ['control_head' , 'admin'] }},
          { path: 'profile', name: 'Profile', component: ProfilePage },
          { path: 'SetNumberScu', name: 'SetNumberScu', component: SetNumberScu },
          { path: 'StudentAbs', name: 'StudentAbs', component: StudentAbs },
          { path: 'StudentAbsAll', name: 'StudentAbsAll', component: StudentAbsAll },
          { path: 'CountStatistics', name: 'CountStatistics', component: CountStatistics },
          { path: 'CountStatisticsAll', name: 'CountStatisticsAll', component: CountStatisticsAll },
          { path: 'DeliveryPortfolio', name: 'DeliveryPortfolio', component: DeliveryPortfolio },
          { path: 'DeliveryPortfolioAll', name: 'DeliveryPortfolioAll', component: DeliveryPortfolioAll },
          { path: 'StoreDegreeStudent_1', name: 'StoreDegreeStudent_1', component: StoreDegreeStudent_1 },
          { path: 'StoreDegreeStudent_2', name: 'StoreDegreeStudent_2', component: StoreDegreeStudent_2 },
          { path: 'SingleGradeEdit', name: 'SingleGradeEdit', component: SingleGradeEdit },
          { path: 'ExternalGradeMonitoring', name: 'ExternalGradeMonitoring', component: ExternalGradeMonitoring },
          { path: 'ReviewGradeSheet', name: 'ReviewGradeSheet', component: ReviewGradeSheet },
          { path: 'ReviewGradeSheetAll', name: 'ReviewGradeSheetAll', component: ReviewGradeSheetAll },
          { path: 'GradeAudit', name: 'GradeAudit', component: GradeAudit },
          { path: 'CheckDegreeFailure', name: 'CheckDegreeFailure', component: CheckDegreeFailure },
          { path: 'CallSheet', name: 'CallSheet', component: CallSheet },
          { path: 'SchoolCallingSheet', name: 'SchoolCallingSheet', component: SchoolCallingSheet },
          { path: 'AbsenceSheetEmpty', name: 'AbsenceSheetEmpty', component: AbsenceSheetEmpty },
          { path: 'CallSheetWithSubjects', name: 'CallSheetWithSubjects', component: CallSheetWithSubjects },
          { path: 'CallSheetWithSubjectsAllMange', name: 'CallSheetWithSubjectsAllMange', component: CallSheetWithSubjectsAllMange },
          { path: 'SeatingReviewReport', name: 'SeatingReviewReport', component: SeatingReviewReport },
          { path: 'AbsenceEntry', name: 'AbsenceEntry', component: AbsenceEntry },
          { path: 'FinalResultPrint', name: 'FinalResultPrint', component: FinalResultPrint },
          { path: 'DigitalResultGazette', name: 'DigitalResultGazette', component: DigitalResultGazette },
          { path: 'FrequencyReport', name: 'FrequencyReport', component: FrequencyReport },
          { path: 'CumulativeFrequency', name: 'CumulativeFrequency', component: CumulativeFrequency },
          { path: 'CumulativeFrequency_1', name: 'CumulativeFrequency_1', component: CumulativeFrequency_1 },
          { path: 'SecretRoomStaticSheet', name: 'SecretRoomStaticSheet', component: SecretRoomStaticSheet },
          { path: 'CommitteeChairmanAgenda', name: 'CommitteeChairmanAgenda', component: CommitteeChairmanAgenda , meta: { roles: ['committee_head'] }},
          { path: 'CommitteeDistribution', name: 'CommitteeDistribution', component: CommitteeDistribution , meta: { roles: ['committee_head'] }},
          { path: 'CommitteeAbsenceRecorder', name: 'CommitteeAbsenceRecorder', component: CommitteeAbsenceRecorder , meta: { roles: ['committee_head'] }},
          { path: 'ActivityFirstOne', name: 'ActivityFirstOne', component: ActivityFirstOne , meta: { roles: ['school_manager'] }},
          { path: 'ActivityAll', name: 'ActivityAll', component: ActivityAll , meta: { roles: ['committee_head', 'admin'] }},
          { path: 'SchoolActivitiesEntry', name: 'SchoolActivitiesEntry', component: SchoolActivitiesEntry , meta: { roles: ['school_manager'] }},
          { path: 'SchoolManagerInstructions', name: 'SchoolManagerInstructions', component: SchoolManagerInstructions , meta: { roles: ['school_manager'] } },
          { path: 'CommitteeCommunication', name: 'CommitteeCommunication', component: CommitteeCommunication , meta: { roles: ['committee_head', 'admin'] }},
          { path: 'MercyRulesManager', name: 'MercyRulesManager', component: MercyRulesManager , meta: { roles: ['committee_head', 'admin'] }},
          { path: 'MercyFullTable', name: 'MercyFullTable', component: MercyFullTable , meta: { roles: ['committee_head', 'admin'] }},
         
          { path: 'AdminSendInstruction', name: 'AdminSendInstruction', component: AdminSendInstruction , meta: { roles: ['admin','operations_admin','control_head'] } },
          { path: 'AdminComplaintsDashboard', name: 'AdminComplaintsDashboard', component: AdminComplaintsDashboard , meta: { roles: ['admin','operations_admin','control_head'] } },
          { path: 'AdminSentInstructionsNotes', name: 'AdminSentInstructionsNotes', component: AdminSentInstructionsNotes , meta: { roles: ['admin','operations_admin','control_head'] } },
          { path: 'AdminSentInstructionsNotes_2', name: 'AdminSentInstructionsNotes_2', component: AdminSentInstructionsNotes_2 , meta: { roles: ['admin','operations_admin','control_head'] } },
          { path: 'Statistics', name: 'Statistics', component: Statistics , meta: { roles: ['admin' ,'operations_admin','control_head'] } },
          
          
          // شغل المطبعة
          { path: 'IntegrationSecretReport', name: 'IntegrationSecretReport', component: IntegrationSecretReport , meta: { roles: ['admin' ,'operations_admin'] } },
          { path: 'SupplementaryExamReport', name: 'SupplementaryExamReport', component: SupplementaryExamReport , meta: { roles: ['admin' ,'operations_admin'] } },
          { path: 'CommitteeSupplementaryReport', name: 'CommitteeSupplementaryReport', component: CommitteeSupplementaryReport , meta: { roles: ['admin' ,'operations_admin'] } },
          { path: 'FullAbsenceReport', name: 'FullAbsenceReport', component: FullAbsenceReport , meta: { roles: ['admin' ,'operations_admin'] } },
          { path: 'SuccessCertificate', name: 'SuccessCertificate', component: SuccessCertificate , meta: { roles: ['admin' ,'operations_admin'] } },
          { path: 'GroupMirrorSheet', name: 'GroupMirrorSheet', component: GroupMirrorSheet , meta: { roles: ['admin' ,'operations_admin'] } },
          { path: 'EnvelopeStickers', name: 'EnvelopeStickers', component: EnvelopeStickers , meta: { roles: ['admin' ,'operations_admin'] } },
          { path: 'SchoolStickerPrint', name: 'SchoolStickerPrint', component: SchoolStickerPrint , meta: { roles: ['admin' ,'operations_admin'] } },
          { path: 'VisualGradeReview', name: 'VisualGradeReview', component: VisualGradeReview , meta: { roles: ['admin' ,'operations_admin'] } },
          { path: 'AnomaliesReview', name: 'AnomaliesReview', component: AnomaliesReview , meta: { roles: ['admin' ,'operations_admin'] } },
          { path: 'GradesCalculator', name: 'GradesCalculator', component: GradesCalculator , meta: { roles: ['admin' ,'operations_admin'] } },
          //   { path: 'register', name: 'Register', component: RegistrationForm }, // مسار تسجيل المتسابق
          // أضف أي مسارات أخرى للوحة التحكم هنا
       
       /* التظلمات */
       
         
          { path: 'CentralPaperMonitor', name: 'CentralPaperMonitor', component: CentralPaperMonitor , meta: { roles: ['admin' ,'operations_admin','control_member'] } },
          { path: 'ReadyAppealsList', name: 'ReadyAppealsList', component: ReadyAppealsList , meta: { roles: ['admin' ,'operations_admin','control_member'] } },
          { path: 'ControlEditAppeal', name: 'ControlEditAppeal', component: ControlEditAppeal , meta: { roles: ['admin' ,'operations_admin','control_member'] } },
          { path: 'FinalAppealMonitor', name: 'FinalAppealMonitor', component: FinalAppealMonitor , meta: { roles: ['admin' ,'operations_admin','control_member'] } },
          { path: 'SystemSettings', name: 'SystemSettings', component: SystemSettings , meta: { roles: ['admin' ,'operations_admin','control_member'] } },
          { path: 'GeneralStatistics', name: 'GeneralStatistics', component: GeneralStatistics , meta: { roles: ['admin' ,'operations_admin','control_member'] } },
          { path: 'SubjectsStatistics', name: 'SubjectsStatistics', component: SubjectsStatistics , meta: { roles: ['admin' ,'operations_admin','control_member'] } },
          { path: 'CommitteeEnvelopeLabel', name: 'CommitteeEnvelopeLabel', component: CommitteeEnvelopeLabel , meta: { roles: ['admin' ,'operations_admin','control_member'] } },
          { path: 'SchoolEnvelopeLabel', name: 'SchoolEnvelopeLabel', component: SchoolEnvelopeLabel , meta: { roles: ['admin' ,'operations_admin','control_member'] } },
          { path: 'ChairmanLoginSheet', name: 'ChairmanLoginSheet', component: ChairmanLoginSheet , meta: { roles: ['admin' ,'operations_admin','control_member'] } },
          { path: 'ExamPaperViewer', name: 'ExamPaperViewer', component: ExamPaperViewer  },
          { path: 'MultiPageScanner', name: 'MultiPageScanner', component: MultiPageScanner  },
          { path: 'AppealReviewPage', name: 'AppealReviewPage', component: AppealReviewPage  },
          { path: 'PaperQualityReview/:subjectId', props: true , name: 'PaperQualityReview', component: PaperQualityReview  },
          { path: 'FinalAdminReport', name: 'FinalAdminReport', component: FinalAdminReport  },
          { path: 'OperationsDashboard', name: 'OperationsDashboard', component: OperationsDashboard  },
          { path: 'MergePaperReceipt', name: 'MergePaperReceipt', component: MergePaperReceipt  },
          { path: 'LanguagePaperPrint', name: 'LanguagePaperPrint', component: LanguagePaperPrint  },
          { path: 'CommitteeStatsReport', name: 'CommitteeStatsReport', component: CommitteeStatsReport  },
          { path: 'SeatingDistribution', name: 'SeatingDistribution', component: SeatingDistribution  },
          { path: 'SeatingCardsPrint', name: 'SeatingCardsPrint', component: SeatingCardsPrint  },
          { path: 'ExportDataCenter', name: 'ExportDataCenter', component: ExportDataCenter  },
        ]
      },
       { 
        path: '/AppealsRequest',
        name: 'AppealsRequest',
        component: AppealsRequest  
      },
       { 
        path: '/ResultPortal',
        name: 'ResultPortal',
        component: ResultPortal  
      },

    {
        path: '/',
        name: 'Home',
        component: HomePage
      },
    {
        path: '/SeatingInquiry',
        name: 'SeatingInquiry',
        component: SeatingInquiry
      },
    {
        path: '/AboutView',
        name: 'AboutView',
        component: AboutView
      },
    // {
    //     path: '/dashboard',
    //     name: 'Dashboard',
    //     component: EvaluationPage,

    // },
    // {
    //     path: '/profile',
    //     name: 'Profile',
    //     component: ProfilePage,
    //     meta: { requiresAuth: true } // يتطلب تسجيل دخول
    // },
    {
        path: '/maintenance',
        name: 'Maintenance',
        component: MaintenancePage,
    },
    // {
    //     path: '/Reports', // رابط صفحة التقارير
    //     name: 'Reports',
    //     component: ReportsPage,
    //     meta: { requiresAuth: true , roles: ['admin', 'judge']} // هذه الصفحة محمية
    // },
    {
        path: '/register', // هذا هو الرابط الجديد
        name: 'Register',
        component: RegistrationForm,
        // هذه الصفحة عامة ولا تتطلب تسجيل دخول
    },
    {
        path: '/login',
        name: 'Login',
        component: Login,
    },
    // {
    //     path: '/',
    //     name: 'Dashboard',
    //     component: Dashboard,
    //     meta: { requiresAuth: true }, // هذه الصفحة تتطلب تسجيل دخول
    // },
    {
        path: '*', // أي مسار آخر غير معرف
        name: 'NotFound',
        component: NotFound
    }
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,

    
});

// حارس التنقل (Navigation Guard) للتحقق من المصادقة
// router.beforeEach((to, from, next) => {
//     const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
//     const isAuthenticated = auth.isAuthenticated();

//     if (requiresAuth && !isAuthenticated) {
//         // إذا كانت الصفحة تتطلب مصادقة والمستخدم غير مسجل دخوله، وجهه لصفحة الدخول
//         next({ name: 'Login' });
//     } else if (to.name === 'Login' && isAuthenticated) {
//         // إذا كان المستخدم مسجل دخوله ويحاول الوصول لصفحة الدخول، وجهه للوحة التحكم
//         next({ name: 'Dashboard' });
//     } else {
//         // اسمح بالوصول في جميع الحالات الأخرى
//         next();
//     }
// });

// router.beforeEach((to, from, next) => {
//     const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
//     const isAuthenticated = auth.isAuthenticated();
//     const user = auth.getUser();
    
//     if (requiresAuth && !isAuthenticated) {
//         next({ name: 'Login' });
//     } else if (requiresAuth && to.meta.roles && !to.meta.roles.includes(user.role)) {
//         // إذا كان المستخدم لا يملك الدور المطلوب، وجهه إلى صفحة غير مصرح بها أو الرئيسية
//         next({ name: 'Reports' }); // أو يمكنك إنشاء صفحة 'Unauthorized'
//     } else {
//         next();
//     }
// });

// دالة لجلب دور المستخدم الحالي (تعتمد على طريقة تخزينك للبيانات)
// غالباً تكون مخزنة في LocalStorage أو Vuex/Pinia
function getUserRole() {
  const user = JSON.parse(localStorage.getItem('user')); // أو Cookies
  return user ? user.role : null;
}

// الحارس (Navigation Guard)
router.beforeEach((to, from, next) => {
  const userRole = getUserRole(); // جلب دور المستخدم
  const requiredRoles = to.meta.roles; // جلب الأدوار المطلوبة للصفحة

  // 1. هل الصفحة تتطلب صلاحيات محددة؟
  if (requiredRoles) {
    
    // أ. إذا لم يكن المستخدم مسجل دخول أصلاً
    if (!userRole) {
      return next({ name: 'Login' });
    }

    // ب. إذا كان المستخدم مسجل دخول، لكن دوره غير موجود في القائمة المسموحة
    // مثلاً: هو 'school' ويحاول دخول صفحة 'usercontrol'
    if (!requiredRoles.includes(userRole)) {
      // توجيهه لصفحة "غير مصرح" أو الصفحة الرئيسية
      return next({ name: 'NotFound' }); 
      // أو return next({ name: 'HomePage' });
    }
  }

  // 2. إذا كانت الصفحة لا تتطلب صلاحيات أو المستخدم يملك الصلاحية
  next(); // اسمح بالمرور
});
export default router;